module.exports = __webpack_public_path__ + "img/mt-generic-user.ce716cb2.png";